import './spinner.css';

const Spinner = () => {
  return (
    <div className='loader-spinner-flex-box'>
        <span class="loader"></span>
    </div>
  )
}

export default Spinner